module.exports = __webpack_public_path__ + "static/img/Onekey.2d6b180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/Onekey.png
// module id = 3oxu
// module chunks = 59